import React, { Component } from 'react'
import FixedView from '../FixedView'
import Collapsible from 'react-collapsible'
import { checkTranslation, translate } from '../../utils/useful'

export default class DashboardsSettingsFrame extends Component {

    state = {
        collapses: {},
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? false : !this.state.collapses[key]
        this.setState({ collapses })
    }

    changeFrame = (item) => {
        // this.props.changePage(item)
        console.log('item is', item)
        this.props.functionsHandler(null, 'changePage', [(item.key ?? item._id)])
        this.framesOptionsList.hideView()
    }

    handelFunction = (mfunction) => {
        if (this[mfunction]) {
            this[mfunction]()
        }
    }

    addPage = () => {
        this.props.functionsHandler(null, 'changePage', ['settings', 'pages', 'new'])
        this.framesOptionsList.hideView()
    }

    addCollection = () => {
        this.props.functionsHandler(null, 'changePage', ['settings', 'collections', 'new'])
        this.framesOptionsList.hideView()
    }


    render() {

        let colors = this.props.colors

        return (
            <div>
                <button onClick={() => this.framesOptionsList.showView()} ref={el => this.framesNode = el} className='flexc mrd-2'>
                    <div className={'flexcc pld-3 prd-4 py-1 br-5  ' + (colors?.iconInvert ? "dark-blur-bg" : 'light-blur-bg')}>
                        <div className='flexcc mrd-1'>
                            <img className={colors?.iconInvert ? 'invert' : ''} width={18} src="/assets/icons/applets/database/frame-white.svg" />
                        </div>
                        <p className='font-size-14 ' style={{ color: colors.textColor }}>{checkTranslation(this.props.currentFrame?.name) ?? translate('Frames')}</p>
                    </div>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.framesOptionsList = el} nodeRef={this.framesNode} xOffset={this.props.language == 'fa' ? 170 : -9} bottomOffset={27} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3  ' >
                        <div className='p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                            <div className="mt-0">
                                <div style={{ borderBottom: '1px solid #eee' }}>
                                    <button onClick={() => this.changeFrame('')} className='flexc w-100 p-2 hover-gray2 br-5 mb-2' >
                                        <div className="flexc">
                                            <img className="transition" src={'/images/icons/gaming-video.png'} height={18} />
                                            <div className='d-flex flex-column mld-3'>
                                                <p className={'font-size-12 weight-500 main-c3'}>{translate("Dashboard")}</p>
                                            </div>
                                        </div>
                                    </button>
                                </div>

                                {Array.isArray(this.props.sections) && this.props.sections?.map((section, i) => {

                                    return (
                                        <div className="w-100 py-2 bb-gray">

                                            <button className="flexcb w-100 p-2 hover-gray br-5" onClick={() => this.changeCollapse(section.key)}>
                                                <div className="flexc">
                                                    <p className="font-size-12 weight-500 main-c3 " style={{}}>{checkTranslation(section.name)}</p>
                                                </div>

                                                <div className='flexc'>
                                                    {section.addNew && (
                                                        <div className="mx-1" onClick={(e) => { e.stopPropagation(); this.handelFunction(section.addNew) }}>
                                                            <div className='br-20' style={{ background: '#ddd' }}>
                                                                <img className={"transition flexcc "} width={18} src='/assets/icons/plus.svg' />
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="">
                                                        <img className={"transition flexcc " + ((this.state.collapses[section.key] == null || this.state.collapses[section.key] == true) ? "" : "rotate-90-rev")} width={18} src='/assets/icons/arrow-down-gray.svg' />
                                                    </div>
                                                </div>
                                            </button>


                                            <Collapsible open={this.state.collapses[section.key] == null ? true : this.state.collapses[section.key]}>
                                                <div className='my-1'>
                                                    {this.props.modules?.map((item, index) => {
                                                        if (section.key == item.section && !item.hideInDashboard)
                                                            return (
                                                                <div className='w-100 my-1' key={index}>
                                                                    <button onClick={() => this.changeFrame(item)} className='flexc w-100 p-2 hover-gray br-5 transition-all'>
                                                                        <div className='flexcc'>
                                                                            <img className="transition-all" src={item.icon ?? '/assets/icons/applets/general/play-games.png'} height={22} />
                                                                        </div>

                                                                        <div className='mld-3'>
                                                                            <p className='font-size-12 main-c3 '>{checkTranslation(item.title ?? item.name)}</p>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            )
                                                    })}
                                                </div>
                                            </Collapsible>

                                            {/* {section.addNew && (
                                                <button className='px-3 mb-1'>
                                                    <p className='text-smaller' style={{ color: '#007aff' }}>+ Add New</p>
                                                </button>
                                            )} */}
                                        </div>
                                    )
                                })}

                            </div>
                        </div>
                    </div>
                </FixedView>
            </div>
        )
    }
}
